import { render, staticRenderFns } from "./CardStatsV4.vue?vue&type=template&id=1049fa82&scoped=true&"
import script from "./CardStatsV4.vue?vue&type=script&lang=js&"
export * from "./CardStatsV4.vue?vue&type=script&lang=js&"
import style0 from "./CardStatsV4.vue?vue&type=style&index=0&id=1049fa82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1049fa82",
  null
  
)

export default component.exports